import { RouteType } from "@routes/interfaces"

const conviteRoutes: RouteType[] = [
    {key: 'conviteDados', path: '/', title: 'Convite'},
    {key: 'conviteFoto', path: '/convite/foto', title: 'Enviar Foto'},
    {key: 'conviteLiveness', path: '/convite/liveness', title: 'Liveness'},
]

export default conviteRoutes